import { render, staticRenderFns } from "./ViewApi.vue?vue&type=template&id=1dbd285f&"
import script from "./ViewApi.vue?vue&type=script&lang=js&"
export * from "./ViewApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports